<template>
  <div class="MemberItem">
    <div class="imgWrap">
      <van-image class="img" :src="detail.avatar || require('@/assets/images/avatar_default_01.png')" fit="cover" round></van-image>
    </div>
    <div class="center">
      <div class="info">
        <div class="name">{{detail.name}}</div>
        <div class="class">{{detail.instituteName}} | {{detail.schoolName}}</div>
      </div>
      <div class="tags">
        <div class="item" v-for="(item,index) in teachSubject" :key="index">{{item}}</div>
      </div>
    </div>
    <div class="right">
      <button class="btn" @click="handleClick">同意</button>
      <button class="btn btn2" @click="cancelClick">不同意</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberItem',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    teachSubject () {
      const { detail: { teachSubject } } = this;
      return teachSubject && teachSubject.split(',') || [];
    }
  },
  methods: {
    handleClick () {
      const { detail } = this;
      this.$emit('handleClick', detail);
    },
    cancelClick () {
      const { detail } = this;
      this.$emit('cancelClick', detail);
    }
  }
};
</script>

<style lang="less" scoped>
.MemberItem {
  margin: 0 auto 20px;
  padding: 30px;
  width: 694px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  .imgWrap {
    width: 92px;
    height: 92px;
    background: #fff;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .img {
      width: 84px;
      height: 84px;
    }
  }
  .center {
    width: 0;
    flex: 1;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .info {
      margin-bottom: 20px;
      .name {
        font-weight: bold;
        font-size: 28px;
        color: #333333;
      }
      .class {
        margin-top: 4px;
        font-size: 22px;
        color: #999AAA;
      }
    }
    .tags {
      display: flex;
      flex-wrap: wrap;
      margin: -5px;
      .item {
        height: 30px;
        border: 1px solid #FC485D;
        border-radius: 40px;
        font-size: 18px;
        color: #FC485D;
        margin: 5px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .right{
    display: flex;
    flex-direction: column;
    .btn {
      width: 116px;
      height: 46px;
      background: #fff;
      border: 2px solid @primaryGreen;
      border-radius: 40px;
      font-size: 24px;
      font-weight: 400;
      color: @primaryGreen;
      margin-bottom: 10px;
      &.btn2 {
        border-color: #999AAA;
        color: #999AAA;
      }
    }
  }

}
</style>